import { render, staticRenderFns } from "./index.vue?vue&type=template&id=1a062a38&scoped=true&lang=true&"
import script from "./news?vue&type=script&lang=js&"
export * from "./news?vue&type=script&lang=js&"
import style0 from "./index.scss?vue&type=style&index=0&id=1a062a38&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a062a38",
  null
  
)

export default component.exports